import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';

import 'styles/Departure/Row.scss';

const DepartureRow = (props) => {
  const {
    departure,
    thereafter,
    showAccessibility,
  } = props;

  if (!departure || !('departure' in departure)) {
    return null;
  }

  return (
    <tr className='DepartureRow'>
      <td
        className={cc([
          'Table__value--numeric',
          'DepartureRow__line',
        ])}
        style={{
          color: departure.colors.foreground,
          backgroundColor: departure.colors.background,
        }}
      >
        {departure.line.shortName}
      </td>
      <td className='DepartureRow__direction'>
        {departure.direction.short}
      </td>
      <td
        className={cc([
          'Table__value--numeric',
          'DepartureRow__track',
        ])}
      >
        {departure.track}
      </td>
      {/* Next and accessibility for that departure */}
      {
        <Fragment>
          {
            showAccessibility &&
            <td
              className={cc([
                'Table__value--numeric',
                'DepartureRow__next',
                'DepartureRow__next-accessibility',
                {
                  'DepartureRow__next--cancelled': departure.departure.cancelled,
                },
              ])}
            >
              {
                departure && departure.accessibility === 'wheelChair' &&
                <span className='material-icons'>
                  accessible
                </span>
              }
            </td>
          }
          <td
            className={cc([
              'Table__value--numeric',
              'DepartureRow__next',
              'DepartureRow__next-wait',
              {
                'DepartureRow__next--cancelled': departure.departure.cancelled,
                'DepartureRow__next-wait--realtime': departure.departure.realtime,
                'DepartureRow__next-wait--cancelled': departure.departure.cancelled,
                'DepartureRow__next-wait--timetable': !departure.departure.realtime,
              },
            ])}
          >
            {
              departure.departure.wait.minutes <= 0
              ? 'nu'
              : departure.departure.wait.minutes
            }
          </td>
        </Fragment>
      }
      {/* Thereafter and accessibility for that departure */}
      {
        <Fragment>
          {
            showAccessibility &&
            <td
              className={cc([
                'Table__value--numeric',
                'DepartureRow__thereafter',
                'DepartureRow__thereafter-accessibility',
                {
                  'DepartureRow__thereafter--cancelled': thereafter && thereafter.departure.cancelled,
                },
              ])}
            >
              {
                thereafter && thereafter.accessibility &&
                <span className='material-icons'>
                  {
                    thereafter.accessibility === 'wheelChair'
                    ? 'accessible'
                    : 'accessibility_new'
                  }
                </span>
              }
            </td>
          }
          <td
            className={cc([
              'Table__value--numeric',
              'DepartureRow__thereafter',
              'DepartureRow__thereafter-wait',
              {
                'DepartureRow__thereafter--cancelled': thereafter && thereafter.departure.cancelled,
                'DepartureRow__thereafter-wait--realtime': thereafter && thereafter.departure.realtime,
                'DepartureRow__thereafter-wait--cancelled': thereafter && thereafter.departure.cancelled,
                'DepartureRow__thereafter-wait--timetable': thereafter && !thereafter.departure.realtime,
              },
            ])}
          >
            {
              !thereafter
              ? '-'
              : thereafter.departure.wait.minutes <= 0
              ? 'nu'
              : thereafter.departure.wait.minutes
            }
          </td>
        </Fragment>
      }
    </tr>
  );
};

const DepartureShape = PropTypes.shape({
  accessibility: PropTypes.string,
  colors: PropTypes.shape({
    background: PropTypes.string,
    foreground: PropTypes.string,
  }),
  departure: PropTypes.shape({
    cancelled: PropTypes.bool,
    date: PropTypes.string,
    realtime: PropTypes.bool,
    time: PropTypes.string,
    wait: PropTypes.shape({
      milliseconds: PropTypes.number,
      minutes: PropTypes.number,
      seconds: PropTypes.number,
    }),
  }),
  direction: PropTypes.shape({
    long: PropTypes.string,
    short: PropTypes.string,
  }),
  line: PropTypes.shape({
    name: PropTypes.string,
    shortName: PropTypes.string,
  }),
  track: PropTypes.string,
  vehicle: PropTypes.string,
});

DepartureRow.propTypes = {
  departure: DepartureShape.isRequired,
  thereafter: DepartureShape,
  showAccessibility: PropTypes.bool.isRequired,
};

DepartureRow.defaultProps = {
  thereafter: null,
  showAccessibility: true,
};

export default DepartureRow;



// WEBPACK FOOTER //
// ./src/components/Departure/Row.jsx